import { Component, EventEmitter, Output } from '@angular/core'
import { NgClass } from '@angular/common'
import { ResponsiveComponent } from '@nx-superprep/shared'

@Component({
  selector: 'pop-ui-handlebar',
  standalone: true,
  imports: [NgClass],
  templateUrl: './handlebar.component.html',
  styleUrls: ['./handlebar.component.scss'],
})
export class HandlebarComponent extends ResponsiveComponent {
  @Output() action = new EventEmitter<Event>()

  onAction(e: Event) {
    this.action.emit(e)
  }

  constructor() {
    super()
    this.rootClassName = 'handlebar-root-class-name'
  }
}
